import axios from 'axios';
import { config } from '../config';
import { authHeader } from '../helpers';

const axiosInstance = axios.create({
  baseURL: '' // your base URL if needed
});

// 🔥 GLOBAL RESPONSE HANDLER
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error?.response?.status;

    // ✅ Handle unauthorized globally
    if (status === 401) {
      // Prevent infinite reload loops
      const currentPath = window.location.pathname;

      // Optional: clear stale auth data
      localStorage.removeItem('user');

      // Redirect instead of reload
      if (currentPath !== '/login') {
        window.location.href = '/login';
      }
    }

    // ✅ Always propagate error
    return Promise.reject(error);
  }
);

export const guidanceToolDataService = {
  getGuidanceToolData
};

function getGuidanceToolData() {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };

  return axiosInstance
    .get(`${config.guidanceToolData_server}/all`, requestOptions)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
}
